@for (award of profileDataService.researcherGrantsHighlights; track award; let i = $index) {
  <div
    class="highlight-wrapper"
    @growOutAnimation
    @opacityInAnimation
    >
    <exl-citation-brief
      [title]="award.grantName"
      [titleClickable]="award.grantURL"
      [titleHeaderLevel]="3"
      [titleUrl]="award.grantURL"
      type="research.awards.grant.type"
      class="is-hoverable"
      >
      <p class="margin-zero semibold">
        @if (award.funderURL) {
          <a [href]="award.funderURL" target="_blank" class="hasnt-color"
            >{{ award.funderCode | defaultTranslate : { default: award.funderName } }}
            @if (award.funderAgencyCode) {
              ({{
              award.funderAgencyCode | defaultTranslate : { default: award.funderAgencyName }
              }})
            }
          </a>
        }
        @if (!award.funderURL) {
          {{ award.funderCode | defaultTranslate : { default: award.funderName } }}
          @if (award.funderAgencyCode) {
            ({{
            award.funderAgencyCode | defaultTranslate : { default: award.funderAgencyName }
            }})
          }
        }
      </p>
      <p>{{ 'research.awards.grant.id' | translate }} {{ award.grantId }}.</p>
      <p>{{ getInvestigatorsStr(award) }}</p>
    </exl-citation-brief>
  </div>
}
